import request from './request';
import env from 'pages/MyAccount/utils/env';

export const getAddresses = () => {
  return request(`${env.user}/users/self/addresses`, 'GET', {
    'Content-Type': 'application/json',
    'FFF-Auth': 'V1.1',
  });
};

export const getAddress = (id) => {
  return request(`${env.user}/users/self/addresses/${id}`, 'GET', {
    'Content-Type': 'application/json',
    'FFF-Auth': 'V1.1',
  });
};

export const updateAddress = (payload, id) => {
  return request(
    `${env.user}/users/self/addresses/${id}`,
    'PUT',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(payload)
  );
};

export const addAddress = (payload) => {
  return request(
    `${env.user}/users/self/addresses`,
    'POST',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(payload)
  );
};

export const removeAddress = (addressId) => {
  return request(`${env.user}/users/self/addresses/${addressId}`, 'DELETE', {
    'Content-Type': 'application/json',
    'FFF-Auth': 'V1.1',
  });
};

export const verifyAddress = (payload) => {
  return request(
    `${env.growth}/location/verify-address`,
    'POST',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(payload)
  );
};
